import React from 'react';

const tones = {
  cyan: 'border-primary/40 text-primary-light bg-primary/10',
  violet: 'border-accent/40 text-accent bg-accent/10',
  success: 'border-success/40 text-success bg-success/10',
  danger: 'border-danger/40 text-danger bg-danger/10',
  neutral: 'border-white/15 text-muted bg-white/[.05]',
};

const Badge = ({ tone = 'neutral', className = '', children }) => (
  <span className={`inline-block rounded-full border px-2.5 py-0.5 text-xs font-medium ${tones[tone]} ${className}`}>
    {children}
  </span>
);

export default Badge;
